<template>
    <Teleport to="body">
                <!-- change status confirmation dialog -->
        <div id="customConfirmationDialog" v-if="isChangeStatusConfirmationOpen" style="z-index: 1500000 !important;">
            <div @click="() => (isChangeStatusConfirmationOpen = false)"
                :class="`modal-backdrop ${isChangeStatusConfirmationOpen ? '' : 'hidden'}`"></div>
            <div id="popupModal" tabindex="-1">
                <div class="fixed modal-inner z-[150] w-[95.5%] max-w-md max-h-full">
                    <div class="relative bg-white rounded-lg modal_inner_dialog">
                        <button @click="() => (isChangeStatusConfirmationOpen = false)" type="button"
                            class="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center">
                            <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd"
                                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                    clip-rule="evenodd" />
                            </svg>
                            <span class="sr-only">Close modal</span>
                        </button>
                        <div class="p-6 text-center">
                            <!-- body -->
                            <svg aria-hidden="true" class="mx-auto mb-4 text-gray-400 w-14 h-14" fill="none"
                                stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <h3 class="mb-5 text-lg font-normal text-gray-500">
                                {{ confirmationDialogData.title }}
                            </h3>
                            <!-- action buttons -->
                            <div class="flex justify-center items-center gap-2">
                                <!-- yes -->
                                <button :disabled="isLoading" @click="()=> {
                                    confirmationDialogData.confirmedFunc();
                                    isChangeStatusConfirmationOpen=false;
                                }"
                                    type="button"
                                    :class="`${isLoading ? 'disabled' : ''} ${confirmationDialogData.isDangerous ? 'bg-red-600 hover:bg-red-800 focus:ring-red-300 text-white' : 'bg-white hover:bg-gray-100 hover:text-gray-900 text-primary border-gray-200 '} border focus:ring-4 focus:outline-none font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2`">
                                    {{ confirmationDialogData.yesButtonTitle || $t('general.yes') }}
                                </button>
                                <!-- no -->
                                <button :disabled="isLoading"
                                    @click="() => (isChangeStatusConfirmationOpen = false)" type="button"
                                    :class="`${isLoading ? 'disabled' : '' } text-primary bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10`">
                                    {{ confirmationDialogData.noButtonTitle || $t('general.no') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>

</template>

<script>
export default {
    name:"ConfirmationDialog",
    data() {
        return {
            isChangeStatusConfirmationOpen:false
        };
    },
    props: {
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        },
        confirmationDialogData: {
            type: Object,
            required: true,
            default:{
                title:'',
                isDangerous: false,
                yesButtonTitle: () => this.$t('general.yes'),
                noButtonTitle: () => this.$t('general.no'),
                confirmedFunc:()=>{}
            }
        },
    },
    methods: {
        openModal(){
            this.isChangeStatusConfirmationOpen=true
        }
    }
};
</script>

<style scoped>
#staticModal {
    position: fixed;
    inset: 0;
    max-height: 100vh;
    max-height: 100svh;
    width: 100%;
    z-index: 150;
}
</style>
